import { LeadCardOrderedProperties } from '@/components/Lead/LeadProperties';
import { LEAD_PROPERTIES } from '@/components/Kanban/VisibilitySettings/constants';
import styles from './LeadDetailsDrawerProperties.less';
import React from 'react';
import { LeadModel } from '@/typings/models/Lead';

export default function LeadDetailsDrawerProperties({
  lead,
  properties,
  ...props
}: {
  lead: LeadModel;
  properties: string[];
}) {
  return (
    <LeadCardOrderedProperties
      grid={{
        sm: 24,
      }}
      overrideVisibleProperties={properties}
      lead={lead}
      showFieldName
      propertyProps={{
        [LEAD_PROPERTIES.ASSIGNEE]: {
          showAssigneeName: true,
        },
      }}
      isTable
      classes={{
        fieldName: styles.leadDetailsFieldName,
        fieldValue: styles.leadDetailsFieldValue,
      }}
      spaceSize={12}
      {...props}
    />
  );
}
